import { Plus } from 'lucide-react'
import { useRef } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router'

import { ClaimsTable } from '@/components/ClaimsTable'
import { OnboardingBannerSlot } from '@/components/OnboardingBannerSlot'
import { useCaiDocked } from '@/components/sidebar'
import { Button } from '@/components/ui/button'
import { useClaims } from '@/models/claim'
import { useFeatureFlag } from '@/models/flag'
import { AskCai, AskCaiChatHandle } from '../../../components/AskCai/AskCai'

export function Claims() {
  const chatRef = useRef<AskCaiChatHandle>(null)
  const caiDocked = useCaiDocked()
  const { claims, isLoading } = useClaims()
  const lifecycleEnabled = useFeatureFlag('ENABLE_CLAIM_LIFECYCLE')

  return (
    <>
      <Helmet>
        <title>Claims</title>
      </Helmet>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[3fr_1fr]">
        <div>
          <div className="mb-2 text-2xl font-semibold">Claims</div>
          <OnboardingBannerSlot className="mb-4" />
          <ClaimsTable
            claims={claims}
            isLoading={isLoading}
            getEditHref={(claim) => `/insure/claims/${claim.id}`}
            allowWithdraw={lifecycleEnabled}
          />
        </div>

        <div className="mt-10 flex flex-col gap-4">
          {!caiDocked && <AskCai ref={chatRef} />}
          <Button asChild className="rounded-full">
            <Link to="/insure/claims/new">
              <Plus />
              Report a claim
            </Link>
          </Button>
        </div>
      </div>
    </>
  )
}
